export const uk = {
    'icon-title': 'Рекомендации',
    'popup-title': 'Рекомендации'
};
